import { useParams } from 'react-router-dom';
import ProjectDetail from '../components/project/ProjectDetail/ProjectDetail';
import { findProjectBySlug } from '../data/projects';
import NotFound from './NotFound';

export default function Project() {
    const { slug } = useParams<{ slug: string }>();
    const project = slug ? findProjectBySlug(slug) : undefined;

    if (!project) return <NotFound />;

    return <ProjectDetail key={project.slug} project={project} />;
}
